import getMyUpsolveEntryUrl from "../Links/getMyUpsolveEntryUrl";
import { CTATrackingTarget } from "../analytics/track";
import upsolveStats from "../../../content/onBuild/upsolveStats.json";
import { P } from "@upsolve/ui";
import React from "react";

export type TCtaCopy = {
  title: string;
  description: Element | string;
  buttonText: string;
  mobileFooterText: string;
};

//for analytics
export enum CTATarget {
  SCREENER = "Screener",
  AJM = "AJM",
  STUDENT_LOANS = "Student Loans",
}

export const getCTARenderedCopy: (targetEntity: CTATarget) => TCtaCopy = (targetEntity: CTATarget) => {
  const entityToData: {
    [key in CTATarget]: TCtaCopy;
  } = {
    [CTATarget.SCREENER]: {
      title: "Considering Bankruptcy?",
      description: (
        <P>
          <b>
            {`Our free tool has helped ${upsolveStats.filings.total.toLocaleString(undefined, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            })}+ families file bankruptcy on their own. `}
          </b>
          We're funded by Harvard University and will never ask you for a credit card or payment.
        </P>
      ),
      buttonText: "Explore Free Tool",
      mobileFooterText: "Bankruptcy Tool",
    },
    [CTATarget.AJM]: {
      title: "Have legal questions?",
      description:
        "If you're a New York resident and want to receive free legal advice on your debt collection lawsuit, we can help!",
      buttonText: "Get Free Help",
      mobileFooterText: "Get Free Help",
    },
    [CTATarget.STUDENT_LOANS]: {
      title: "Want to erase your student loan debt?",
      description: "If you qualify, Upsolve can help you erase it.",
      buttonText: "Check Eligibility",
      mobileFooterText: "Student Loans Help",
    },
  };
  return entityToData[targetEntity || CTATarget.SCREENER];
};

export const getCTAURL: (targetEntity: CTATarget, params?: { [key: string]: string }) => string = (
  targetEntity: CTATarget,
  params?: { [key: string]: string }
) => {
  const entityToData: { [key in CTATarget]: string } = {
    [CTATarget.SCREENER]: getMyUpsolveEntryUrl(params || {}),
    [CTATarget.AJM]: `https://notionforms.io/forms/upsolve-ajm-debt-lawsuit-advising-service-interest-form`,
    [CTATarget.STUDENT_LOANS]:
      "https://app.immigrationhelp.org/upsolve-student-loan-discharge-intake?access_key=2Pj74k6I6SaURnvz4Q37zBcgH",
  };
  return entityToData[targetEntity || CTATarget.SCREENER];
};

export const getCTATrackingTarget = (targetEntity: CTATarget) => {
  const entityToData: { [key in CTATarget]: CTATrackingTarget } = {
    [CTATarget.SCREENER]: CTATrackingTarget.SCREENER,
    [CTATarget.AJM]: CTATrackingTarget.AJM,
    [CTATarget.STUDENT_LOANS]: CTATrackingTarget.STUDENT_LOANS,
  };
  return entityToData[targetEntity || CTATarget.SCREENER];
};
